
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 16a2 2 0 102 2 1.993 1.993 0 00-2-2M0 0v2h2l3.6 7.59-1.36 2.45A2.038 2.038 0 004 13a2 2 0 002 2h12v-2H6.42a.25.25 0 01-.25-.25.213.213 0 01.03-.12L7.1 11h7.45a2.011 2.011 0 001.75-1.03l3.58-6.47A1.265 1.265 0 0020 3a1 1 0 00-1-1H4.21l-.94-2M6 16a2 2 0 102 2 1.993 1.993 0 00-2-2z","fill":"#fff"}})])
          )
        }
      }
    